import * as pdfjs from 'pdfjs-dist'
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.mjs?url'

let initialized = false

export const initPdfWorker = () => {
  if (!initialized) {
    pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl
    initialized = true
  }
}
